// extracted by mini-css-extract-plugin
export default {"user__container":"styles_user__container__YIVdU"};